<template>
  <body>
    <div class="increase">
      <div class="text-wrapper">
        <div class="text">Wecobi can increase full-price sales by up to</div>
        <div class="number">42%</div>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  name: "Banner",
};
</script>

<style scoped>
.increase {
  width: 100%;
  height: 500px;
  border-radius: 20px;
  background-image: url("../../../../assets/banners/increase.jpeg");
  background-position: 0 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.text-wrapper {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.57);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 20px;
}
.text {
  font-size: 50px;
  font-weight: 600;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  max-width: 650px;
}
.number {
  font-size: 100px;
  font-weight: 600;
  line-height: 120px;
  background-image: linear-gradient(
    to right,
    rgba(249, 129, 64, 1),
    rgba(252, 186, 105, 1)
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
@media (max-width: 1280px) {
  .text {
    font-size: 35px;
    max-width: 450px;
  }
  .number {
    font-size: 90px;
  }
}

@media (max-width: 1024px) {
  .text {
    font-size: 30px;
    max-width: 390px;
  }
  .number {
    font-size: 80px;
  }
}
@media (max-width: 430px) {
  .text {
    max-width: 326px;
  }
}
</style>
